import React, {Component} from 'react';
import {connect} from 'react-redux';

@connect(
    state => ({
        isOpen: state.mobileNav.isOpen,
        component: state.mobileNav.component,
        props: state.mobileNav.props
    })
)
export default class MobileNavDropdown extends Component {
    render() {
        if(! this.props.isOpen) {
            return null;
        }

        return (
            <div id="mobile-nav-dropdown">
                {this.props.component}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/MobileNavDropdown.js